import React from 'react';
import BackToTopButton from '../BackToTopButton';

var Wrapper = function Wrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center relative text-left pt-16 pb-40 min-h-screen bg-secondary before:content-[''] before:w-full before:h-full before:absolute before:top-0 before:left-0 before:z-0 before:opacity-50 before:bg-custom-white"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-[90vw] block mx-auto relative z-10"
  }, children), /*#__PURE__*/React.createElement(BackToTopButton, null));
};

var ResultItem = function ResultItem(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement("p", {
    className: "pb-5 text-custom-gray leading-snug text-[clamp(2.4rem,calc(1rem+1vw),3.6rem)] md:text-3-6 mb-10 last:mb-0 border-b border-solid border-custom-gray last:border-b-0"
  }, children);
};

var SearchResults = function SearchResults(_ref3) {
  var results = _ref3.results,
      feedbackMessage = _ref3.feedbackMessage;

  if (feedbackMessage) {
    return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(ResultItem, null, feedbackMessage));
  }

  if (!results.length) {
    return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(ResultItem, null, "No found any joke belongs your search term!"));
  }

  return /*#__PURE__*/React.createElement(Wrapper, null, results.map(function (result) {
    return /*#__PURE__*/React.createElement(ResultItem, {
      key: result.id
    }, result.joke);
  }));
};

export default SearchResults;